import React from 'react';
import translatePage from '../i18n/translatePage';
import useTranslation from '../hooks/useTranslation';

import SiteMetadata from '../components/SiteMetadata';
import TMarkUp from '../components/TMarkUp';

const NotFoundPage = (): JSX.Element => {
  const { t } = useTranslation();

  return (
    <>
      <SiteMetadata pageTitle={t('app.htmlTitle')} />
      <h1 className="h2">
        <TMarkUp value={t('error.title-404')} />
      </h1>
      <p>
        <TMarkUp value={t('error.description-404')} />
      </p>
    </>
  );
};

export default translatePage()(NotFoundPage);
